import { Box, styled } from '@mui/material';
import { pxToRem } from '../../../utils/getFontValue';
import { UIColors } from '../../../constants/UIConstants';

export const SubStepContainer = styled(Box)`
  flex: 1;
  background-color: ${UIColors.globalBG.white};
  min-height: ${pxToRem(100)};
  height: 100%;
  border-radius: ${pxToRem(8)};
  border: 1px solid ${UIColors.neutrals.grey40};
  box-shadow: 0 1px 4px rgba(19, 7, 57, 0.07);
  overflow: hidden;
`;

export const SubStepTitleBox = styled(Box)`
  background-color: ${UIColors.primary.grey};
  height: 3.438rem;
  border-bottom: ${pxToRem(4)} solid ${UIColors.secondary.emarald};
`;

export const SubStepBody = styled(Box)`
  min-height: 6.25rem;
  padding: ${pxToRem(28)} ${pxToRem(40)};
  width: 100%;
  display: flex;
  flex-direction: column;
`;
